export enum BonusStatusEnum {
  Recieved = 1,
  Spend,
};
